import React from 'react'
import 'react-modern-calendar-datepicker/lib/DatePicker.css'
import { Calendar } from 'react-modern-calendar-datepicker'
import { themes } from 'theme/styled'
import { CalendarMonthContainer } from './CalendarMonth.styled'
import { CalendarMonthProps } from './CalendarMonth.props'

const CalendarMonth = ({ currentDate, onSelectedDate }: CalendarMonthProps) => {
  return (
    <CalendarMonthContainer>
      <Calendar
        colorPrimary={themes.Light.colors.primary}
        value={currentDate}
        onChange={onSelectedDate}
      />
    </CalendarMonthContainer>
  )
}

export default CalendarMonth
